module.exports = {
	"classes": [
		"mfa-page"
	],
	"title": "Auth0 Guardian",
	"metas": {
		"description": "Multifactor Made Easy: The most usable and friction-free multifactor authentication experience available"
	},
	"opengraph": {
		"og:title": "Auth0 Guardian",
		"og:description": "Multifactor Made Easy: The most usable and friction-free multifactor authentication experience available",
		"og:url": "https://auth0.com/guardian",
		"og:image": "https://cdn.auth0.com/website/assets/pages/guardian/assets/social-card-db858f505b.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/guardian/assets/social-card-db858f505b.png"
	},
	"twittercard": {
		"twitter:title": "Auth0 Guardian",
		"twitter:description": "Multifactor Made Easy: The most usable and friction-free multifactor authentication experience available",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/guardian/assets/social-card-db858f505b.png",
				"width": "2400",
				"height": "1260"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/guardian/metadata.json
// module id = 1118
// module chunks = 0